/*
 * Copyright (c) 2023. Collabro Limited
 */

import { ThemeOptions } from "@mui/material/styles";
import modecBig from "../../images/modecBig.png";
import modecSmall from "../../images/modecSmall.svg";

//MODEC Blue: #0d3692
//MODEC Red: #ee3a42
//Corporate Gray: #808080
//Safety White: #FFFFFF
//Innovation Green: #00CC66

const ModecLight: ThemeOptions = {
  //Company Config
  name: "Modec",
  logo: {
    big: modecBig,
    small: modecSmall,
  },
  components: {
    MuiFilledInput: {
      styleOverrides: {
        input: {
          "&:-webkit-autofill": {
            transitionDelay: "9999s",
          },
        },
      },
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#0d3692",
    },
    secondary: {
      main: "#ee3a42",
    },
    text: {
      primary: "#1F271B",
    },
    modal: {
      main: "#fff",
    },
    cells: {
      offshore: {
        text: "#D1D1D1",
        background: "#0d3692",
      },
      nightShift: {
        text: "#454545",
        background: "#F0D3F7",
      },
      flight1: {
        text: "#393939",
        background: "#A0D2DB",
      },
      waitlist: {
        text: "#454545",
        background: "#F3DE8A",
      },
      exclusion: {
        text: "#020202",
        background: "#989788",
      },
      otherLocation: {
        text: "#020202",
        background: "#CCF5AC",
      },
    },
  },
};

export default ModecLight;
